import { useQuery } from '@tanstack/react-query';

import CookieConsentServiceInstance from '@services/CookieConsentService';
import type { CookieCategory } from '@shared-types/optanon.types';

export const useCookieConsent = (category: CookieCategory) => {
  const alreadyAccepted = CookieConsentServiceInstance.getCookiesAccepted(category);
  const { data: accepted } = useQuery({
    queryKey: ['cookie-consent', category],
    queryFn: () => CookieConsentServiceInstance.waitForCookiesAccepted(category),
    placeholderData: alreadyAccepted,
    enabled: !alreadyAccepted,
  });

  return accepted;
};
